import { route, tag, type PageTour } from '../pageTour';

export const alertActionsTour: PageTour = {
  id: 'page-alert-actions',
  version: 2,
  title: 'Alerts — Config & Actions',
  summary: 'What raises an alert on each site and on the cloud, and who hears about it.',
  match: route('/alert-actions'),
  steps: [
    {
      target: tag('alert-actions-sites'),
      title: 'Pick a site — or the cloud',
      description:
        'Everything here is set site by site. "Cloud (platform)" at the top is the cloud server itself. The badge shows who sends each site\'s notifications.',
      side: 'right',
    },
    {
      target: tag('alert-actions-rules'),
      title: 'Config and actions',
      description:
        'Alert Config holds the site\'s AI rules, its CPU / memory / disk rules and its offline alert. Alert Actions decides who is told: the site or the cloud sends, and to which recipients — a site\'s alerts only reach that site\'s people.',
      side: 'left',
    },
    {
      target: tag('alert-actions-refresh'),
      title: 'Channels and log',
      description:
        'Delivery channels set up the cloud\'s email and messaging; Delivery log shows what was sent and to whom. Refresh reloads everything.',
      side: 'bottom',
    },
  ],
};
